import { forwardRef } from 'react';

import cn from 'classnames';

import { ComposerFrame } from './_components/layout/ComposerFrame';
import { ComposerHeader } from './_components/layout/ComposerHeader';
import type { CommunityPostComposerHandle, CommunityPostComposerProps } from './CommunityPostComposer.type';
import { CommunityPostComposerCore } from './CommunityPostComposerCore';

export const CommunityPostComposer = forwardRef<CommunityPostComposerHandle, CommunityPostComposerProps>(
  (
    {
      destinations,
      selectedDestination,
      onDestinationChange,
      destinationMode = 'selectable',
      author,
      onClose,
      className,
      notice,
      ...coreProps
    },
    ref,
  ) => (
    <ComposerFrame className={cn(className, { hidden: coreProps.isHidden })}>
      <ComposerHeader
        destinations={destinations}
        selectedDestination={selectedDestination}
        onDestinationChange={onDestinationChange}
        destinationMode={destinationMode}
        author={author}
        onClose={onClose}
        translations={coreProps.translations}
      />
      {notice ? <div className="px-4 pt-4">{notice}</div> : null}
      <CommunityPostComposerCore ref={ref} {...coreProps} />
    </ComposerFrame>
  ),
);

CommunityPostComposer.displayName = 'CommunityPostComposer';
